<template lang="pug">
  div.download.pointer(@click="download(arquivo)")
    div.nome {{arquivo.nome}}
    div.icon
      i.fas.fa-download
</template>

<script>
export default {

  props: {
    arquivo: {
      type: Object,
      required: true
    }
  },

  methods: {
    download (arquivo) {
      this.$emit('download', arquivo)
    }
  }

}
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";

.pointer {
  cursor: pointer;
}

.download:nth-child(odd) {
  background-color: $verylightgray-color;
}

.download {
  padding: 1rem;
  padding-left: 1rem;
  padding-right: 1rem;
  height: 3rem;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.nome {
  font-size: 0.9rem;
}
</style>



// WEBPACK FOOTER //
// src/components/AppDownloadArquivo.vue